import { create } from 'zustand';

export interface ProjectRoleEntry {
  project: string;
  role: string;
  environments?: string[] | null;
}

export interface UserProfile {
  displayName: string;
  email: string;
  role: 'Admin' | 'Reviewer' | 'Developer' | 'ReadOnly';
  globalRole?: string | null;
  projectRoles?: ProjectRoleEntry[];
  repositories: string[];
}

export interface AuthStore {
  status: 'loading' | 'authenticated' | 'unauthenticated' | 'error';
  user: UserProfile | null;
  error: string | null;
  setAuthenticated: (user: UserProfile) => void;
  setUnauthenticated: () => void;
  setLoading: () => void;
  setError: (error: string) => void;
}

export const useAuthStore = create<AuthStore>((set) => ({
  status: 'loading',
  user: null,
  error: null,

  setAuthenticated: (user: UserProfile) =>
    set({ status: 'authenticated', user, error: null }),

  setUnauthenticated: () =>
    set({ status: 'unauthenticated', user: null, error: null }),

  setLoading: () =>
    set({ status: 'loading', error: null }),

  setError: (error: string) =>
    set({ status: 'error', error }),
}));
